<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    hide-header-close
    centered
    no-close-on-esc
    no-close-on-backdrop
  >
    <div class="p-2">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/fail.svg"
        alt="Pendaftaran Ditolak"
        class="mx-auto mb-2 w-24 h-24"
      >
      <div class="mb-2 text-center">
        <h2 class="font-bold text-black text-2xl mb-1">
          Pendaftaran Ditolak
        </h2>
        <p class="text-secondary">
          Silahkan ajukan pendaftaran ulang untuk bisa menggunakan Komads
          Whitelisted
        </p>
      </div>
      <h5 class="font-weight-bold text-black text-base">
        Alasan Penolakan
      </h5>
      <div class="border rounded-lg p-1 mb-2 text-left min-h-32">
        <p class="mb-0 text-base">
          {{ message }}
        </p>
      </div>
      <b-button
        variant="primary"
        block
        @click="$bvModal.hide(id)"
      >
        Oke
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'modal-pendaftaran-ditolak',
    },
    message: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.text-black {
  color: #333333;
}
</style>
